import { render, staticRenderFns } from "./autre-prestation.html?vue&type=template&id=3566e0fb&scoped=true&external"
import script from "./autre-prestation.js?vue&type=script&lang=js&external"
export * from "./autre-prestation.js?vue&type=script&lang=js&external"
import style0 from "./autre-prestation.scss?vue&type=style&index=0&id=3566e0fb&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3566e0fb",
  null
  
)

export default component.exports